{
  "success": true,
  "errorMessage": "",
  "codeUsage": [
    {
      "productType": "TRAVEL",
      "transactionType": "POL",
      "expirationDate": 1719935688257,
      "discountPerc": 25,
      "isAffinity": 0,
      "logic": 2
    }
  ]
}
